module.exports = __webpack_public_path__ + "1d1faa88f026fca54806b3aa4643bc22.jpg";